import { loadable } from '@shared/core/loadableFromNamedExport';

/**
 * Lazy `StatusBannerConfetti`. Keeps `react-confetti` out of the guest body chunk: the banner
 * only opens for a `?bannerKey` matching the `websiteBannerMapping` flag payload, so the
 * library is fetched only when a guest actually sees it.
 */
export const LazyStatusBannerConfetti = loadable(
  () => import(/* webpackChunkName: "content/guest/site/status-banner-confetti" */ './StatusBannerConfetti'),
  'StatusBannerConfetti',
);
